import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeamsBranding = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 15,
		height: 15,
		rx: 3.5,
		fill: "#0EA5E9",
		stroke: "#0284C7"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(3.66667 3.66667)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.723984 6.86111H7.94621V7.58333H0.723984V6.86111ZM0.723984 1.80556L2.52954 2.88889L4.3351 0.722222L6.14066 2.88889L7.94621 1.80556V6.13889H0.723984V1.80556Z",
			fill: "white"
		})
	})]
});
const ForwardRef = forwardRef(SvgTeamsBranding);
export default ForwardRef;
